import React from 'react';
import Table from 'core/components/VirtualTable';
import {
  ServiceAllocation,
} from 'pages/Dashboard/pages/Billing/types';
import {
  invoiceColumns,
} from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/columns';

type Props = {
  data: ServiceAllocation[];
};

const blockedCells = new Set(['copay', 'deductible', 'coinsurance']);

export default function ServiceBreakdownView({ data }: Props) {
  return (
    <Table<ServiceAllocation>
      key="visitNoteBillingCodeId"
      classes={{
        scrollContainer: 'justify-center items-center !pb-0',
        column: '!text-left',
        row: 'hover:before:!bg-transparent',
        scrollbarGutter: 'initial',
        footer: '!w-full',
        cell: ({ original }, { column }) => {
          const isCustomServices = original?.type === 'custom';
          const isBlocked = blockedCells.has(column?.id);

          return (isCustomServices && isBlocked) ? 'blocked-cell' : '';
        },
      }}
      columns={invoiceColumns}
      data={data}
      hasFooter
    />
  );
}
